export const paymentSettingsRouteNames = {
  settings: 'payment-settings',
  settingsReceipts: 'payment-settings-receipts',
  settingsTaxes: 'payment-settings-taxes',
  settingsNotifications: 'payment-settings-notifications',
  settingsShipping: 'payment-settings-shipping',
  settingsSubscriptions: 'payment-settings-subscriptions',
  settingsPaymentLinks: 'payment-settings-payment-links',
  settingsMiscellaneousCharges: 'payment-settings-misc-charges',
}
